<template>
    <div class="loginfo-container">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
            <el-form :inline="true" :model="filters">
                <el-form-item label="关键字">
                    <el-input size="small" v-model="filters.search" placeholder="姓名，手机号关键字"></el-input>
                </el-form-item>
                <el-form-item>
                    <dateOptionSelector :options="dateOptions" v-model="filters.dateTime" :multiple="true" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" v-on:click="queryPageList">查询</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <el-table stripe border size="mini" :data="tableData" highlight-current-row expand-on-click-node="false"
            style="width: 100%">
            <el-table-column fixed="left" prop="MemberTraining.TraningType" label="计划" width="120" sortable>
                <template slot-scope="scope">
                    <el-tag type="primary">{{ format.dateFormat(scope.row.MemberTraining.ScheduleBeginDate) }}</el-tag>
                    <el-tag type="danger">{{ format.dateFormat(scope.row.MemberTraining.ScheduleEndDate) }}</el-tag>

                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="Member" label="姓名" width="120" sortable> <template slot-scope="scope">
                    <div class="link" v-if="scope.row.MemberTraining.Member">
                        {{ scope.row.MemberTraining.Member.RealName }} <el-tag type="primary">{{
                            scope.row.MemberTraining.Member.Mobile }}</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="left" prop="Date" label="计划日期/项目" width="120" sortable>
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.Date) }}
                    <el-tag type="primary">{{
                        scope.row.Name }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="ResponseDate" label="反馈时间" width="110" sortable>
                <template slot-scope="scope">
                    {{ format.dateFormat(scope.row.ResponseDate) }}
                </template>
            </el-table-column>
            <el-table-column label="匹兹堡睡眠质量指数" header-align="center">
                <el-table-column v-for="(item, index) in question1" :label="item">
                    <template slot-scope="scope">
                        <div v-if="scope.row.AddInfo && scope.row.AddInfo.split('&').length > index">
                            {{ scope.row.AddInfo.split('&')[index] }}
                        </div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="POMS心境状态" header-align="center">
                <el-table-column v-for="(item, index) in question2" :label="item">
                    <template slot-scope="scope">
                        <div v-if="scope.row.AddInfo2 && scope.row.AddInfo2.split('&').length > index">
                            {{ scope.row.AddInfo2.split('&')[index] }}
                        </div>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="pageSizesList" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total" :current-page.sync="pageIndex"></el-pagination>
        </div>
    </div>
</template>
<script>
import { GetTraningList } from "@/api/traning/traning";
import dateOptionSelector from "@/components/dateOptionSelector";
export default {
    components: {
        dateOptionSelector,
    },
    data() {
        return {
            filters: {
                search: "",
                traningType: "Cryotherapy",
                dateTime: {
                    dateType: "date",
                    date: [],
                },
            },
            dateOptions: [
                { value: "date", name: '计划日期' },
                { value: "response", name: '反馈时间' }
            ],
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            pageSizesList: [10, 15, 20, 30, 50],

            question1: ["上床时间",
                "入睡时长",
                "起床时间",
                "实际睡眠时长",
                "入睡困难",
                "夜间易/早醒",
                "夜间去厕所",
                "呼吸不畅",
                "咳嗽/鼾声高",
                "睡觉感觉冷",
                "睡觉感到太热",
                "做噩梦",
                "疼痛不适",
                "其他影响睡眠",
                "近一个月睡眠质量",
                "近一个月药物催眠",
                "近一个月感到困倦",
                "近一个月精力不足"
            ],
            question2: ["紧张的", "生气的", "不快活的",
                "轻松愉快的", "慌乱的", "心烦意乱的",
                "气坏的", "劳累的", "悲伤的", "精神饱满的", "集中不了注意力的",
                "自信的", "内心不安的", "气恼的", "筋疲力尽的", "沮丧的",
                "主动积极的", "慌张的", "坐卧不安的", "烦恼的",
                "倦息的", "忧郁的", "兴致勃勃的",
                "健忘的", "有能力感的", "易激动的", "有能力感的",
                "抱怨的", "孤弱无助的", "劲头十足的", "自豪的"],
        };
    },
    methods: {
        queryPageList: function () {
            let data = {
                pageSize: this.pageSize,
                traningType: this.filters.traningType,
                pageIndex: this.pageIndex,
                search: this.filters.search,
                dateType: this.filters.dateTime.dateType,
                beginDate:
                    this.filters.dateTime.date.length > 0
                        ? this.filters.dateTime.date[0]
                        : "",
                endDate:
                    this.filters.dateTime.date.length > 1
                        ? this.filters.dateTime.date[1]
                        : "",
            };
            GetTraningList(data).then((response) => {
                this.listLoading = false;
                if (response) {
                    this.tableData = response.Items;
                    this.total = response.Total || response.Items.length;
                }
            });
        },
        handleSizeChange(val) {
            var pageSize = `${val}`;
            this.pageIndex = 1;
            this.pageSize = parseInt(pageSize);
            this.$nextTick(() => this.queryPageList());
        },
        handleCurrentChange(val) {
            this.pageIndex = `${val}`;
            this.queryPageList();
        },
        handleDelete(row) {
            this.$confirm("确认删除该天计划吗？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let parma = { key: row.Key };
                del(parma).then((res) => {
                    if (res) {
                        this.queryPageList();
                    }
                });
            });
        },
    },
    mounted() {
        this.queryPageList();
    },
};
</script>

<style lang='scss' scoped>
.loginfo-container {
    padding: 10px;
}

/deep/.el-dialog {
    margin-top: 10px !important;
}
</style>
